/**
 * Where the page that bounced a visitor to the auth screens wants them back
 * (`ProtectedRoute` sets `state.from`). Only an in-app path is honoured — a
 * protocol-relative `//host` or absolute URL would turn the redirect into an open one.
 */
export function returnPath(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  return typeof from === 'string' && /^\/(?![/\\])/.test(from) ? from : '/';
}

/** Router `state` that carries the return path across a Login ⇄ Register switch. */
export function returnState(path: string): { from: string } | undefined {
  return path === '/' ? undefined : { from: path };
}
